const formatFloat = (arithmetics: number) => {
  return +arithmetics.toFixed(10);
};
export { formatFloat };
